<template>
  <div class='main'>
    <div class='menuContainer' :style="`width:${isHidden?'0':'221px'}`">
      <div class='hiddenIcon' @click='hiddenTab'>
        <i :class="isHidden?'el-icon-caret-right':'el-icon-caret-left'" style='color:#fff' />
      </div>
      <el-menu
        :default-active='pathActive'
        text-color='#335483'
        active-text-color='#fff'
        :unique-opened='true'
        style='width: 221px'
        :style="`transform:translateX(${isHidden?'-221px':'0'});transition: all .3s;`"
        @select='selectMenu'
        router
      >
        <!--        <el-submenu index="/contract/list" v-has="'pc_contract_manage'">-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-order" style="color:#335483"/>-->
        <!--            <span>合同管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group v-has="'pc_contract_list'">-->
        <!--            <el-menu-item index="/contract/list">合同列表</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--          <el-menu-item-group v-has="'pc_contract_examine'">-->
        <!--            <el-menu-item index="/contract/audit">合同审核</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!--        <el-submenu index="/contract/type" v-has="'pc_contract_configer'">-->
        <!--          <template slot="title">-->
        <!--            <i class="el-icon-s-tools" style="color:#335483"/>-->
        <!--            <span>合同配置</span>-->
        <!--          </template>-->
        <!--          <el-menu-item-group v-has="'pc_contract_type'">-->
        <!--            <el-menu-item index="/contract/type">合同类型</el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->

        <!--解除权限-->
        <el-submenu index='/contract/list' v-has="'pc_contract_manage'">
          <template slot='title' v-has="'pc_contract_manage'">
            <i class='el-icon-s-order' style='color:#335483' />
            <span>合同管理</span>
          </template>
          <el-menu-item-group v-has="'pc_contract_list'">
            <el-menu-item index='/contract/list'>合同列表</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_contract_price'">
            <el-menu-item index='/contract/priceReview'>价格评审</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_contract_type'">
            <el-menu-item index='/contract/type' v-has="'pc_contract_type'">合同类型配置</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/contract/assessment'>
          <template slot='title' v-has="'pc_supplier'">
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>供应商考核</span>
          </template>
          <el-menu-item-group v-has="'pc_supplier_daily'">
            <el-menu-item index='/contract/daily'>日常考核</el-menu-item>
          </el-menu-item-group>

          <el-menu-item-group v-has="'pc_supplier_monthly'">
            <el-menu-item index='/contract/monthly'>月考核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_supplier_monthly_manage'">
            <el-menu-item index='/contract/monthlyAssessmentIndexSetting'>指标设置</el-menu-item>
          </el-menu-item-group>
          <!--          <el-menu-item-group >-->
          <!--            <el-menu-item index="/contract/trainRecord">培训记录</el-menu-item>-->
          <!--          </el-menu-item-group>-->
        </el-submenu>
        <el-submenu index='/contract/train'>
          <template slot='title' v-has="''">
            <i class='el-icon-edit' style='color:#335483;font-weight: 700' />
            <span>培训管理</span>
          </template>
          <el-menu-item-group v-has="''">
            <el-menu-item index='/contract/trainRecord'>培训记录</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class='content2' :style="`width:${isHidden?'100%':'calc(100% - 221px)'}`"
         style='background-color: rgb(244, 247, 251);'>
      <router-view v-if="$route.path.split('/').length>=3"
                   style='background-color: rgb(244, 247, 251);min-height: calc(100% - 60px)' />
      <Home v-else style='min-height: calc(100% - 60px)' />
      <div class='footer-div'>渝ICP备2022002327号-1</div>
      <!-- <div class="footer">
        <div style="min-width: 300px;color: #677788;text-align: center;">渝ICP备2022002327号-1</div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import Home from '@/views/home/main';

  export default {
    components: {
      Home,
    },

    data() {
      return {
        pathActive: null,
        activeNum: 1,
        isHidden: false,
      };
    },
    watch: {
      $route(to, from) {
        this.pathActive = this.$route.path;
      },
    },
    mounted() {
      this.pathActive = this.$route.path;
    },
    methods: {
      hiddenTab() {
        this.isHidden = !this.isHidden;
      },
      selectMenu() {
        this.activeNum = 0;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;

    .menuContainer {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      position: relative;
      transition: all .3s;
      height: calc(100vh - 70px);
      overflow-x: hidden;

      .hiddenIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #48599E;
        width: 11px;
        height: 50px;
        position: absolute;
        top: calc(50% - 20px);
        right: -11px;
        border-radius: 0 10px 10px 0;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .content {
      width: calc(100% - 221px);
      height: calc(100vh - 70px);
      overflow: auto;
    }

    .content2 {
      transition: all .3s;
      width: 100%;
      height: calc(100vh - 70px);
      overflow: auto;

      .footer {
        width: 100%;
        background-color: white;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        /*position: fixed;*/
        /*z-index: 99999;*/
      }
    }

    ::v-deep {
      .el-menu-item.is-active {
        background-color: #335483;
      }

      .el-menu-item:focus {
        outline: 0;
        background-color: #335483;
      }
    }

    .content2 > .contract-list, .content2 > .electrify,
    .content2 > .operation, .content2 > .consignSettle,
    .content2 > .portSettle, .content2 > .stockpile,
    .content2 > .warehouse, .content2 > .deferlnvoicing,
    .content2 > .massLoss-list, .content2 > .logisticsConfig,
    .content2 > .finance-income, .content2 > .price-highway,
    .content2 > .main, .content2 > .supplierTrain,
    .content2 > .otherFees, .content2 > .mainContainer,
    .content2 > .carModel, .content2 > .price-Review,
    .content2 > .contract-type, .content2 > .consignor-daily,
    .content2 > .consignor-train {
      height: calc(100% - 30px);
      overflow-y: auto;
    }

    .footer-div {
      display: block;
      position: relative;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 30px;
      font-size: 13px;
      line-height: 30px;
      text-align: center;
      color: #a8a8a8;
      background-color: #f4f7fb;
    }
  }
</style>
